import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "samplecomponent" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1>Colors</h1><div class=\"samplecomponent__article\"><h2>basic</h2><div class=\"container--overflow\"><div class=\"color__grid\"><div class=\"color__column\" style=\"--samplecolors-bg-color:var(--color-white);\"><span class=\"color__variable\">--color-white</span></div><div class=\"color__column\" style=\"--samplecolors-bg-color:var(--color-white-100);\"><span class=\"color__variable\">--color-white-100</span></div><div class=\"color__column\" style=\"--samplecolors-bg-color:var(--color-black);\"><span class=\"color__variable\" style=\"color:white;\">--color-black</span></div></div></div></div>", 2)
const _hoisted_4 = { class: "container--overflow" }
const _hoisted_5 = { class: "color__grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors, (color) => {
      return (_openBlock(), _createBlock("div", {
        class: "samplecomponent__article",
        key: color
      }, [
        _createVNode("h2", null, _toDisplayString(color), 1),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            (_openBlock(), _createBlock(_Fragment, null, _renderList(8, (i) => {
              return _createVNode("div", {
                class: "color__column",
                key: i,
                style: _ctx.setCssVariables(color, i)
              }, [
                _createVNode("span", {
                  class: ["color__variable", 'color__variable--'+i]
                }, "--color-" + _toDisplayString(color) + "-" + _toDisplayString(i) + "00", 3)
              ], 4)
            }), 64))
          ])
        ])
      ]))
    }), 128))
  ]))
}